import React from 'react';
import NO_DATA_IMG from './images/noData.svg';
import NO_DATA_DARK_IMG from './images/noData-dark.svg';
import { Box, Typography } from '@material-ui/core';
import { useCommonStyles } from './styles';

export const NoData = ({ mode }) => {
  const commonClasses = useCommonStyles({ mode });

  return (
    <Box
      height="calc(100% - 42px)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection={'column'}
    >
      <img
        src={mode === 'dark' ? NO_DATA_DARK_IMG : NO_DATA_IMG}
        alt="No Data Available"
        style={{ marginBottom: 16 }}
      />
      <Typography classes={{ root: commonClasses.fontRegular }}>
        No Data Available!
      </Typography>
    </Box>
  );
};
